import { ROUTES } from "../../config/routes.const"
import {
  UserData,
  UpdateUserData,
  LoginResponse,
  smsCodeResponse,
} from "../../types/userTypes"
import { api, updateApiHeaders } from "./apiConfig"
import sha1 from "sha1"

const DeviceTypeId = 99

export async function login(
  email: string,
  password: string,
): Promise<LoginResponse[]> {
  const loginData = {
    userName: email,
    password: password,
  }
  try {
    delete api.defaults.headers.common["x-Token"];
    delete api.defaults.headers.common["x-Customer"];
    const response = await api.post("/Security/Login", loginData)

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function getUser(): Promise<UserData> {
  try {
    const response = await api.get("/GetUser/Get")

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function sendVerificationCode(
  phoneNumber: string,
): Promise<smsCodeResponse> {
  try {

    delete api.defaults.headers.common["x-Token"];
    delete api.defaults.headers.common["x-Customer"];

    const response = await api.post("/Security/SMSCodeRequest", {
      phoneNumber,
    })

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function verifyCode(
  pin: string,
  phoneNumber: string,
  verificationIdentity: string,
): Promise<LoginResponse[]> {
  const requestData = {
    phoneNumber,
    verificationCode: pin,
    verificationIdentity,
    DeviceTypeId,
  }
  try {
    const response = await api.post("/Security/SMSLogin", requestData)

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function sendForgotPasswordEmail(email: string): Promise<any> {
  try {
    const forgotPasswordData = {
      Username: email,
      Email: null,
    }
    const response = await api.post(
      "/Security/ForgotPassword",
      forgotPasswordData,
    )

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function changePassword(
  oldPassword: string,
  newPassword: string,
  credentialId: number,
) {
  try {
    const response = await api.post("/GetUser/ResetPassword", {
      oldPassword,
      newPassword,
      credentialId,
    })

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function resetPassword(newPassword: string, token: string) {
  try {
    const response = await api.post("/Security/UpdatePasswordByToken", {
      newPassword: newPassword,
      token,
    })

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function changePincode(
  oldPincode: string,
  newPincode: string,
  credentialId: number,
) {
  try {
    const response = await api.post("/GetUser/", {
      oldPincode,
      newPincode,
      credentialId,
    })

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function updateUser(updatedUserData: UpdateUserData) {
  try {
    const response = await api.put("/GetUser/Update", updatedUserData)

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function getCCIFrameURL(
  requestOptions: any,
): Promise<string | any> {
  try {
    const response = await api.post("/MagicRegistration/GetCCIFrameURL", {
      requestOptions,
    })

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export const refreshUserByToken = async (token: string) => {
  try {
    const redirectRes: any = await api.post("/Security/LoginRedirect", {
      token,
    })

    const refreshRes: any = await api.post("/Security/LoginRefresh", {
      ...redirectRes.data,
    })

    if (redirectRes.data) {
      updateApiHeaders(
        refreshRes.data[0].token,
        refreshRes.data[0].customerToken,
      )
      localStorage.setItem("x-Token", refreshRes.data[0].token)
      localStorage.setItem("x-Customer", refreshRes.data[0].customerToken)
      window.location.href = ROUTES.MY_RIDES
    }
  } catch (err) {
    console.log(err)
  }
}
